<template>
  <div class="profile-form guest-profile form form-default" v-if="guestProfileState || is_direct" data-testid="guest-profile-form">
        <div class="profile__container padded-top-block orange-bordered" data-testid="profile-container">
          <router-link to="/" class="icon-btn conference-close" data-testid="profile-close-button">
            <img src="@/assets/icons/xmark.svg" alt="Close">
          </router-link>
          <div class="profile-form form form-default">
            <form action="#" method="POST" @submit.prevent="guestProfileUpdate" data-testid="guest-form">
            <div class="form-row">
              <label for="#profile_name">{{ $t('profile_name') }}</label>
              <input type="text" required name="name" v-model="guest.name" class="form-input form-input--text" placeholder="" id="profile_name" data-testid="profile-name-input">
            </div>

            <div class="form-row">
              <label for="#profile_password">{{ $t('profile_language') }}</label>
              <language-selector :initial="guest.language" @select="selectLanguage"></language-selector>
            </div>

            <div class="form-row">
              <label for="#profile_name">{{ $t('profile_voice_tone') }}</label>
              <div class="radio-tabs">
                <label class="radio-tabs__btn" id="voice_male">
                      <input type="radio" v-model="guest.voice" name="voice" value="male" class="hidden-radio" data-testid="voice-male-radio"/>
                      <span class="radio-tabs__visual">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <rect width="26" height="26" fill="url(#pattern0)"/>
                          <defs>
                          <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                          <use xlink:href="#image0_187_168" transform="scale(0.0104167)"/>
                          </pattern>
                          <image id="image0_187_168" width="96" height="96" xlink:href="data:image/png;base64,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"/>
                          </defs>
                        </svg>
                        {{ $t('enum_voicegender_male') }}
                      </span>
                </label>
                <label class="radio-tabs__btn" id="voice_female">
                      <input type="radio" v-model="guest.voice" name="voice" value="female" class="hidden-radio" data-testid="voice-female-radio"/>
                      <span class="radio-tabs__visual">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <rect width="26" height="26" fill="url(#pattern0)"/>
  <defs>
  <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
  <use xlink:href="#image0_187_169" transform="scale(0.0104167)"/>
  </pattern>
  <image id="image0_187_169" width="96" height="96" xlink:href="data:image/png;base64,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"/>
  </defs>
  </svg>
                        {{ $t('enum_voicegender_female') }}
                      </span>
                </label>
              </div>
            </div>
            <div class="margined-submit">
              <button type="submit" name="profile_submit" id="profile_submit" class="orange-btn form-btn" value="Join">{{ $t('common_join') }}</button>
            </div>
          </form>
          </div>

        </div>
      </div>
  <div class="room-code-wrap" v-else>
    <router-link to="/" class="icon-btn conference-close">
      <img src="@/assets/icons/xmark.svg" alt="Close"> <!-- TODO: replace with icons font -->
    </router-link>
    <div class="guest-info" v-show="!is_host">
      {{ $t('join_conversation')}}, <br>
      <b>{{ $t('join_conversation_room_code')}}</b>
    </div>
    <div class="otp-wrap">
      <v-otp-input
        ref="roomCodeInput"
        input-classes="roomcode-input"
        separator=""
        :num-inputs="6"
        :should-auto-focus="!$isMobile()"
        :is-input-num="true"
        :is-disabled="is_host"
        :conditionalClass="['num_0', 'num_1', 'num_2', 'num_3', 'num_4', 'num_5']"
        :placeholder="['', '', '', '', '', '']"
        @on-change="handleOnChange"
        @on-complete="handleOnComplete"
      />
    </div>

    <div class="qr-scan" v-if="qrScanEnabled" data-testid="qr-scan">
      <div class="qr-scan__title">{{ translateOr('join_scan_qr_code', 'Or scan a QR code') }}</div>
      <div class="qr-scan__frame">
        <!-- Must stay visible (no v-show): qr-scanner permanently collapses a video that is hidden at init.
             Until the camera is active the placeholder covers it. -->
        <video ref="qrVideo" class="qr-scan__video" playsinline muted data-testid="qr-scan-video"></video>
        <button
          type="button"
          class="qr-scan__placeholder"
          v-if="qrCameraState !== 'active'"
          @click="startQrScanner"
          data-testid="qr-scan-placeholder"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/>
            <circle cx="12" cy="13" r="3.5"/>
          </svg>
          <span>{{ qrPlaceholderText }}</span>
        </button>
        <span class="qr-scan__corner qr-scan__corner--tl"></span>
        <span class="qr-scan__corner qr-scan__corner--tr"></span>
        <span class="qr-scan__corner qr-scan__corner--bl"></span>
        <span class="qr-scan__corner qr-scan__corner--br"></span>
      </div>
    </div>

    <div class="join-footer" v-if="lastEvent && lastEvent.code">
      <router-link :to="`/room/${lastEvent.code}`" class="orange-link orange-link--inline">{{ $t('join_last_session') }}</router-link>
    </div>
    
    <div class="copy-clipboard" v-if="is_host">
      <a href="javascript:;" class="orange-link text-transform-none" @click="clipboardCopy"><img src="@/assets/icons/clipboard.svg"/>{{ $t('code_copy_clipboard') }}</a>
    </div>
    <div class="code-info" :class="status">{{ statusText }}</div>
    <!--<div class="room-qr-code">
      <qrcode-vue :value="event.room_code" :size="200" level="H" margin="2"/>
    </div>-->
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import VOtpInput from 'vue3-otp-input';
import QrScanner from 'qr-scanner';
import LanguageSelector from '@/components/LanguageSelector.vue';
//import QrcodeVue from 'qrcode.vue'

export default {
  name: 'EventStart',
  data() {
    return {
      status: "",
      statusText: "",
      guestProfileState: false,
      sessionPassword: "",
      qrScanEnabled: false,
      qrCameraState: 'pending', // pending | active | blocked | unavailable
      qrStartId: 0,
      qrJoining: false,
      qrFailedCode: null,
    }
  },
  props: {
    is_host: {
      type: Boolean,
      required: true
    },
    is_guest: {
      type: Boolean,
      required: false,
      default: true
    },
    is_direct: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    VOtpInput,
    LanguageSelector
    //QrcodeVue
  },
  methods: {
    guestProfileUpdate() {
      this.$store.dispatch("event/setGuestProfile", this.guest).then(
          () => {
            setTimeout(() => {
                this.goToRoom();
            }, 1000)
          }
      );
    },
    selectLanguage(langCode) {
      this.guest.language = langCode;
    },
    setGuestProfileState(bool) {
      this.guestProfileState = bool;
    },
    setSecureState(bool) {
      this.secureState = bool;
    },
    goToRoom() {
      this.$router.push(`/room/${this.event.room_code}`);
      this.$emit('confirmed');
    },
    handleOnComplete (v) {
      this.statusText = this.$t('status_joining');
      this.status = "joining";

      return this.$store.dispatch("event/join", v).then(
          () => {
              this.stopQrScanner();
              setTimeout(() => {
                if (!this.authorized && !this.$isMobile()) {
                  this.$store.dispatch("event/setGuestProfile", this.guest).then(
                      () => {
                        this.goToRoom();
                      }
                  );
                } else {
                  this.goToRoom();
                }
              }, 1000)
              return true;
          },
          () => {
            this.status = "error";
            this.statusText = this.$t('error_session_not_found');
            return false;
          }
      );
    },
    async startQrScanner() {
      if (!this.qrScanEnabled || this.qrCameraState === 'active' || this.isUnmounted) {
        return;
      }

      // A pending permission prompt may never resolve (dismissed/ignored), so every
      // tap on the placeholder starts over and stale attempts are ignored by id
      this.stopQrScanner();
      const startId = ++this.qrStartId;
      this.qrCameraState = 'pending';

      await this.$nextTick();
      if (!this.$refs.qrVideo) {
        return;
      }

      const scanner = new QrScanner(this.$refs.qrVideo, this.handleQrResult, {
        preferredCamera: 'environment',
        maxScansPerSecond: 5,
        returnDetailedScanResult: true,
      });
      this.qrScanner = scanner;

      try {
        await scanner.start();
        if (startId !== this.qrStartId || this.isUnmounted) {
          scanner.destroy();
          return;
        }
        this.qrCameraState = 'active';
      } catch (e) {
        if (startId !== this.qrStartId) {
          return;
        }
        this.stopQrScanner();
        this.qrCameraState = String(e).includes('not found') ? 'unavailable' : 'blocked';
      }
    },
    translateOr(key, fallback) {
      return this.$te(key) ? this.$t(key) : fallback;
    },
    stopQrScanner() {
      if (this.qrScanner) {
        this.qrScanner.destroy();
        this.qrScanner = null;
      }
    },
    parseRoomCode(data) {
      const value = (data || '').trim();
      if (/^\d{6}$/.test(value)) {
        return value;
      }
      try {
        const match = new URL(value).pathname.match(/\/room\/(\d{6})\/?$/);
        return match ? match[1] : null;
      } catch (e) {
        return null;
      }
    },
    handleQrResult(result) {
      const code = this.parseRoomCode(result.data);
      if (!code || this.qrJoining || code === this.qrFailedCode) {
        return;
      }

      this.qrJoining = true;
      this.handleOnComplete(code).then((joined) => {
        this.qrJoining = false;
        if (!joined) {
          this.qrFailedCode = code;
        }
      });
    },
    handleOnChange() {
      this.statusText = "";
      this.status = "typing";
    },
    clipboardCopy() {
       navigator.clipboard.writeText(this.event.room_code);
      this.$toast.success('code_copy_clipboard_complete');
    }
  },
  computed: {
     ...mapState('auth', ['token', 'authorized', 'user']),
     ...mapState('event', ['event', 'guest', 'lastEvent']),
    ...mapState('nonpersist', ['sessionPassword']),
    qrPlaceholderText() {
      if (this.qrCameraState === 'blocked') {
        return this.translateOr('join_scan_qr_camera_blocked', 'Camera access is blocked. Allow it in browser settings and tap to retry');
      }
      if (this.qrCameraState === 'unavailable') {
        return this.translateOr('join_scan_qr_camera_not_found', 'Camera not found. Tap to retry');
      }
      return this.translateOr('join_scan_qr_camera_allow', 'Tap to allow camera access');
    },
  },
  mounted() {
    this.qrScanEnabled = !this.is_host && !this.is_direct && this.$isMobile()
      && window.isSecureContext && !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
    this.startQrScanner();
  },
  beforeUnmount() {
    this.isUnmounted = true;
    this.stopQrScanner();
  }
}
</script>

<style lang="scss">
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .otp-input.is-complete {
    background-color: #e4e4e4;
  }

  .roomcode-input {
    opacity: 1;
    width: 86.61px;
    height: 112px;

    border: 5px solid #DADADA;
    border-radius: 22.8571px;
    background: transparent;
    margin-right: 7px;
    font-weight: 700;
    font-size: 4.7rem;
    line-height: 100%;
    color: #fff;
    text-align: center;
    outline: none;

    &.is-complete, &:focus {
      border: 5px solid #6CBFFF;
    }

    &::selection, &::-moz-selection {
      background: transparent;
    }
  }

  .copy-clipboard {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .room-qr-code {
    margin-top: 30px;
    display: flex;
    justify-content: center;

    canvas {
      mix-blend-mode: normal;
      filter: drop-shadow(0px 7.54966px 7.54966px rgba(0, 0, 0, 0.25));
      border-radius: 9.43707px;
      
    }
  }

  .guest-info {
    font-style: normal;
    font-weight: 300;
    font-size: 1.5rem;
    line-height: 1.125rem;
    /* identical to box height */

    display: flex;
    text-align: center;
    flex-direction: column;
    text-transform: uppercase;
    margin-bottom: 30px;
    color: #FFFFFF;

    b {
      font-weight: 700;
      font-size: 1.875rem;
      line-height: 2.8rem;
    }
  }

  .code-info {
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 2.375rem;
    text-transform: uppercase;
    text-align: center;
    margin-top: 28px;

    &.joining {
      color: #6CBFFF;
    }

    &.error {
      color: #FF1400;
    }
  }

  .room-code-wrap {
    position: relative;
  }

  @media all and (max-height: 800px) {
    .room-qr-code {
      margin-top: 0 !important;
    }
  }

  @media all and (max-width: 767px) {
    .room-code-wrap {
      padding: 0 16px;
      
      .otp-wrap {
        & > div {
          column-gap: 10px;
        }
      }

      .roomcode-input {
        width: 100%;
        height: auto;
        aspect-ratio: 86.61 / 112;
        border-radius: 13px;
        margin: 0;
        font-size: 2.7rem;
      }

      .conference-close {
        display: none;
      }

      .guest-info {
        font-size: 1.125rem;
        line-height: 1.5rem;
        margin-bottom: 24px;

        b {
          font-size: 1.25rem;
          line-height: 1.75rem;
        }
      }

      .join-footer a {
        font-size: 1.125rem;
      }
    }
  }

  .qr-scan {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 40px;

    &__title {
      font-size: 1rem;
      line-height: 1.5rem;
      color: #fff;
    }

    &__frame {
      position: relative;
      width: 240px;
      max-width: 100%;
      aspect-ratio: 1 / 1;
      background: rgba(0, 0, 0, 0.3);
    }

    &__video {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__placeholder {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
      padding: 24px;
      background: rgba(255, 255, 255, 0.06);
      border: none;
      color: #6CBFFF;
      font-size: 0.875rem;
      line-height: 1.25rem;
      text-align: center;
      cursor: pointer;

      span {
        color: rgba(255, 255, 255, 0.85);
      }
    }

    &__corner {
      position: absolute;
      width: 56px;
      height: 56px;
      border: 0 solid #6CBFFF;
      pointer-events: none;

      &--tl { top: 0; left: 0; border-top-width: 3px; border-left-width: 3px; }
      &--tr { top: 0; right: 0; border-top-width: 3px; border-right-width: 3px; }
      &--bl { bottom: 0; left: 0; border-bottom-width: 3px; border-left-width: 3px; }
      &--br { bottom: 0; right: 0; border-bottom-width: 3px; border-right-width: 3px; }
    }
  }

  .form-title {
    h3 {
      color: #fff;
      margin: 0 0 40px;
      font-size: 1.4rem;
    }
  }

  .join-footer {
    display: flex;
    margin-top: 80px;
    justify-content: center;

    a {
      font-size: 1.8rem;
    }
  }
</style>
